import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { ValidationService } from '../../../shared/services/validation.service';

@Component({
    templateUrl: 'menstrual-period.component.html'
})

export class MenstrualPeriodComponent implements OnInit {

    // public newConditionName = '';

    public maxDate = new Date();

    public lastMenstrualPeriodTimeStamp = null;

    public menstrualPeriodForm: FormGroup;

    constructor(public formBuilder: FormBuilder,
        @Inject(MD_DIALOG_DATA) public data: any,
        public dialogRef: MdDialogRef<MenstrualPeriodComponent>) {
        this.createForm();
    }

    createForm() {
        this.menstrualPeriodForm = this.formBuilder.group({
            lastMenstrualPeriodDate: [this.lastMenstrualPeriodTimeStamp, [ValidationService.isValidDateOfLastMenstrualPeriod]]
        });
    }

    ngOnInit() {
        this.lastMenstrualPeriodTimeStamp = (this.data ? new Date(this.data) : null) || null;
        const today = new Date();
        const dd = today.getDate();
        const mm = today.getMonth();
        const yyyy = today.getFullYear();
        this.maxDate = new Date(yyyy, mm, dd);
    }

    onDateChange(event) {
        // ValidationService.validationDate(this.menstrualPeriodForm.controls['lastMenstrualPeriodDate'], event);
    }

    onCloseConfirm() {
        if (this.menstrualPeriodForm.valid) {
            const date = new Date(this.lastMenstrualPeriodTimeStamp).setHours(new Date().getHours());
            const data = {
                isSuccess: true,
                date: date
            };
            this.dialogRef.close(data);
        }
    }

    onCloseDialog() {
        this.dialogRef.close(false);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/medical-conditions/menstrual-period.component.ts